module.exports = __webpack_public_path__ + "static/media/logo.9c341a86.svg";